import pull from 'lodash/pull'
import xor from 'lodash/xor'
import { defineStore } from 'pinia'

function normalizeAnimalId(animalId: string | number): number {
  return typeof animalId === 'string' ? Number.parseInt(animalId) : animalId
}

const STORE_NAME = 'wish-list'

// Note that this storage is set up as localStorage
export const useWishListStore = defineStore(STORE_NAME, {
  state: () => ({
    profile: [] as number[],
  }),
  getters: {
    isFavorite: (state) => (animalId: string | number) => state.profile.includes(normalizeAnimalId(animalId)),
    hasFavorites: (state) => state.profile.length > 0,
    getFavorites: (state) => state.profile || [],
  },
  actions: {
    reset() {
      if (this.profile.length) {
        this.profile = []
      }
    },
    setFavorites(animalIds: (string | number)[]) {
      this.profile = animalIds.map((animalId) => normalizeAnimalId(animalId))
    },
    mergeFavorites(profile: (string | number)[]) {
      // Only merge when the current profile is empty and the new profile is not empty
      // Otherwise we choose to ignore the merge request, because there is no way we can determine which version is better
      if (this.profile.length === 0 && profile?.length > 0) {
        this.profile = profile.map((animalId) => normalizeAnimalId(animalId))
      }
    },
    toggleFavorite(animalId: string | number) {
      this.profile = xor(this.profile, [normalizeAnimalId(animalId)])
    },
    removeFavorite(animalId: string | number) {
      const newProfile = pull(this.profile, normalizeAnimalId(animalId))
      // Yes... the two lines below are the same, but without the second reassignment the values do not update reactively
      this.profile = newProfile
      this.profile = newProfile
    },
  },
  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
    key: `db-${STORE_NAME}`,
  },
})
